export const en = {
  'memberClasses.description': 'Pick a class and book your place.',
  'memberClasses.view.week': 'Week',
  'memberClasses.view.month': 'Month',
  'memberClasses.view.list': 'List',
  'memberClasses.thisWeek': 'This week',
  'memberClasses.thisMonth': 'This month',
  'memberClasses.previousWeek': 'Previous week',
  'memberClasses.nextWeek': 'Next week',
  'memberClasses.previousMonth': 'Previous month',
  'memberClasses.nextMonth': 'Next month',
  'memberClasses.nextTwoWeeks': 'Next 14 days',
  'memberClasses.allClasses': 'All classes',
  'memberClasses.filterClass': 'Filter by class',
  'memberClasses.clearFilters': 'Clear filters',
  'memberClasses.noneWeek': 'No classes this week',
  'memberClasses.noneMonth': 'No classes this month',
  'memberClasses.noneList': 'No classes in the next two weeks',
  'memberClasses.noneDay': 'No classes on this day.',
  'memberClasses.noneHint': 'The gym has not published sessions for these dates yet.',
  'memberClasses.noneFiltered': 'No classes match these filters',
  'memberClasses.started': 'Started',
  'memberClasses.unavailable': 'Not available',
  'memberClasses.opensShort': 'Opens {opensAt}',
  'memberClasses.refusal.MEMBERSHIP_REQUIRED': 'You need a membership that is active at this time.',
  'memberClasses.refusal.MEMBERSHIP_NOT_STARTED': 'Your membership starts on {startsAt}.',
  'memberClasses.refusal.PLAN_NO_CLASSES': 'Your plan does not include classes.',
  'memberClasses.refusal.PLAN_NOT_ALLOWED': 'This class is not open to your plan.',
  'memberClasses.refusal.LOCATION_NOT_ALLOWED': 'Your plan does not open this branch.',
  'memberClasses.refusal.PLAN_HOURS': 'Your plan does not let you in at this time.',
  'memberClasses.refusal.WEEKLY_LIMIT': 'You have used your {limit} bookings for this week.',
  'memberClasses.refusal.TOO_MANY_BOOKINGS': 'You already have {max} upcoming bookings.',
  'memberClasses.refusal.BOOKING_NOT_OPEN': 'Booking opens {opensAt}.',
  'memberClasses.refusal.BOOKING_CLOSED': 'Booking has closed.',
  'memberClasses.refusal.MEMBER_BLOCKED': 'Your account is blocked. Ask at the front desk.',
  'memberClasses.refusal.NO_CLASS_VISITS_LEFT': 'Your class pack has no visit left that is valid when this class starts.',
  'memberClasses.packs.title': 'My class packs',
  'memberClasses.packs.summary': '{left} of {total} visits left · use by {date}',
  'memberClasses.packs.classes': 'Classes: {classes}',
  'memberClasses.waiting': '{count} waiting',
  'memberClasses.more': '+{count} more',
  'memberClasses.time': 'Time',
  'memberClasses.weekTable': 'Classes this week by day and start time',
  'memberClasses.chooseDay': 'Choose a day',
  'memberClasses.classCount.one': '{count} class',
  'memberClasses.classCount.other': '{count} classes',
  'memberClasses.bookedToast': 'Class booked',
  'memberClasses.waitlistedToast': 'Added to the waitlist',
  'memberClasses.cancelledToast': 'Booking cancelled',
};

export const ka: Record<keyof typeof en, string> = {
  'memberClasses.description': 'აირჩიეთ ვარჯიში და დაჯავშნეთ ადგილი.',
  'memberClasses.view.week': 'კვირა',
  'memberClasses.view.month': 'თვე',
  'memberClasses.view.list': 'სია',
  'memberClasses.thisWeek': 'ეს კვირა',
  'memberClasses.thisMonth': 'ეს თვე',
  'memberClasses.previousWeek': 'წინა კვირა',
  'memberClasses.nextWeek': 'შემდეგი კვირა',
  'memberClasses.previousMonth': 'წინა თვე',
  'memberClasses.nextMonth': 'შემდეგი თვე',
  'memberClasses.nextTwoWeeks': 'მომდევნო 14 დღე',
  'memberClasses.allClasses': 'ყველა ვარჯიში',
  'memberClasses.filterClass': 'ვარჯიშის მიხედვით ფილტრი',
  'memberClasses.clearFilters': 'ფილტრების გასუფთავება',
  'memberClasses.noneWeek': 'ამ კვირაში ვარჯიშები არ არის',
  'memberClasses.noneMonth': 'ამ თვეში ვარჯიშები არ არის',
  'memberClasses.noneList': 'მომდევნო ორ კვირაში ვარჯიშები არ არის',
  'memberClasses.noneDay': 'ამ დღეს ვარჯიშები არ არის.',
  'memberClasses.noneHint': 'დარბაზს ამ თარიღებისთვის ვარჯიშები ჯერ არ გამოუქვეყნებია.',
  'memberClasses.noneFiltered': 'ამ ფილტრებით ვარჯიშები ვერ მოიძებნა',
  'memberClasses.started': 'დაიწყო',
  'memberClasses.unavailable': 'მიუწვდომელია',
  'memberClasses.opensShort': 'იხსნება {opensAt}',
  'memberClasses.refusal.MEMBERSHIP_REQUIRED': 'ამ დროს მოქმედი აბონემენტი გჭირდებათ.',
  'memberClasses.refusal.MEMBERSHIP_NOT_STARTED': 'თქვენი აბონემენტი იწყება {startsAt}-ს.',
  'memberClasses.refusal.PLAN_NO_CLASSES': 'თქვენი პაკეტი ჯგუფურ ვარჯიშებს არ მოიცავს.',
  'memberClasses.refusal.PLAN_NOT_ALLOWED': 'ეს ვარჯიში თქვენი პაკეტისთვის ხელმისაწვდომი არ არის.',
  'memberClasses.refusal.LOCATION_NOT_ALLOWED': 'თქვენი პაკეტი ამ ფილიალში არ მოქმედებს.',
  'memberClasses.refusal.PLAN_HOURS': 'თქვენი პაკეტით ამ დროს დარბაზში შესვლა არ შეიძლება.',
  'memberClasses.refusal.WEEKLY_LIMIT': 'ამ კვირის {limit} ჩაწერა უკვე გამოიყენეთ.',
  'memberClasses.refusal.TOO_MANY_BOOKINGS': 'უკვე გაქვთ {max} მომავალი ჩაწერა.',
  'memberClasses.refusal.BOOKING_NOT_OPEN': 'ჩაწერა გაიხსნება {opensAt}.',
  'memberClasses.refusal.BOOKING_CLOSED': 'ჩაწერა დასრულდა.',
  'memberClasses.refusal.MEMBER_BLOCKED': 'თქვენი ანგარიში დაბლოკილია. მიმართეთ მიმღებს.',
  'memberClasses.refusal.NO_CLASS_VISITS_LEFT': 'თქვენს პაკეტში ამ ვარჯიშის დაწყებისას მოქმედი ვიზიტი აღარ დარჩა.',
  'memberClasses.packs.title': 'ჩემი ჯგუფური ვარჯიშების პაკეტები',
  'memberClasses.packs.summary': 'დარჩა {left} / {total} ვიზიტი · გამოიყენეთ {date}-მდე',
  'memberClasses.packs.classes': 'ვარჯიშები: {classes}',
  'memberClasses.waiting': '{count} რიგში',
  'memberClasses.more': '+{count} კიდევ',
  'memberClasses.time': 'დრო',
  'memberClasses.weekTable': 'ამ კვირის ვარჯიშები დღეებისა და დაწყების დროის მიხედვით',
  'memberClasses.chooseDay': 'აირჩიეთ დღე',
  'memberClasses.classCount.one': '{count} ვარჯიში',
  'memberClasses.classCount.other': '{count} ვარჯიში',
  'memberClasses.bookedToast': 'ვარჯიში დაჯავშნილია',
  'memberClasses.waitlistedToast': 'დაემატეთ მოლოდინის სიაში',
  'memberClasses.cancelledToast': 'ჯავშანი გაუქმდა',
};
